export default __webpack_public_path__ + "static/media/Deloitte - Logo.46ffb6ff.png";